const updates = [
  { date: '07-31', title: '《星落凝成糖》全40集上线，陈星旭李兰迪演绎仙侠虐恋', tag: '新剧上线' },
  { date: '07-30', title: '《长风渡》更新至第36集，白敬亭宋轶先婚后爱口碑爆棚', tag: '热播更新' },
  { date: '07-30', title: '经典港剧《陀枪师姐》全系列高清修复版完整收录', tag: '经典回归' },
  { date: '07-29', title: '《向往的生活》第七季更新至第8期，何炅黄磊温情收官', tag: '综艺更新' },
  { date: '07-29', title: '豆瓣9.2分纪录片《地球脉动》第三季4K超清版全8集更新', tag: '高分推荐' },
  { date: '07-28', title: '《狂飙》全39集张译张颂文演技封神，现象级国产剧在线看', tag: '热播推荐' },
  { date: '07-28', title: '迪士尼动画《寻梦环游记》中配版上线，温暖治愈催泪神作', tag: '动画上线' },
  { date: '07-27', title: '《新闻女王》佘诗曼回归TVB力作，职场宫斗高能不断更新中', tag: '港剧热播' },
];

const tagColors: Record<string, string> = {
  '新剧上线': 'bg-primary-100 text-primary-700',
  '热播更新': 'bg-accent-100 text-accent-800',
  '经典回归': 'bg-secondary-100 text-secondary-700',
  '综艺更新': 'bg-accent-100 text-accent-800',
  '高分推荐': 'bg-primary-100 text-primary-700',
  '热播推荐': 'bg-accent-100 text-accent-800',
  '动画上线': 'bg-secondary-100 text-secondary-700',
  '港剧热播': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            追剧快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新上架与更新动态，不再错过任何一部好剧
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-background-200 -translate-x-1/2 hidden md:block"></div>

          <div className="space-y-4 md:space-y-0">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-0 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  {i % 2 === 0 ? (
                    <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
                      <div className="flex items-center gap-2 mb-2 md:justify-end">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                          {item.tag}
                        </span>
                      </div>
                      <p className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                        {item.title}
                      </p>
                    </div>
                  ) : (
                    <div className="md:invisible md:h-0"></div>
                  )}
                </div>

                <div className="hidden md:flex items-center justify-center flex-shrink-0 w-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>
                </div>

                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-left md:pl-12' : 'md:text-right md:pr-12'}`}>
                  {i % 2 === 1 ? (
                    <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
                      <div className="flex items-center gap-2 mb-2 md:justify-start">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                          {item.tag}
                        </span>
                      </div>
                      <p className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                        {item.title}
                      </p>
                    </div>
                  ) : (
                    <div className="bg-background-100 rounded-xl p-4 border border-background-200/60 md:hidden">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                          {item.tag}
                        </span>
                      </div>
                      <p className="text-sm font-medium text-foreground-900 leading-relaxed">
                        {item.title}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}